<template>
  <div>
    <!-- <h1>LOGIN</h1> -->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'login',

}
</script>

<style>
